export default "__VITE_ASSET__CrD9p2y3__"